export default __webpack_public_path__ + "static/media/LandingDevice1.36b7ee29.png";